import { render, staticRenderFns } from "./CoachingOnboardingSubscription.vue?vue&type=template&id=b2c6e1c4&scoped=true&"
import script from "./CoachingOnboardingSubscription.vue?vue&type=script&lang=js&"
export * from "./CoachingOnboardingSubscription.vue?vue&type=script&lang=js&"
import style0 from "./CoachingOnboardingSubscription.vue?vue&type=style&index=0&id=b2c6e1c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c6e1c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VDataTable,VIcon,VRow,VTextField})
